import { WarehouseMovementCreateRequest, WarehouseMovementEditRequest, WarehouseMovementGetRequest } from '@dave/types';
import { createAction, props } from '@ngrx/store';
import { WarehouseMovementEntity } from '../../entities/warehouseMovement.entity';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';

const prefix = 'data/' + 'warehouseMovement/';
export const WarehouseMovementActionTypes = {
    // Load: createAction(prefix + 'load', props<{ Payload: WarehouseMovementGetRequest }>()),
    // Change: createAction(prefix + 'change', props<{ Payload: WarehouseMovementEditRequest }>()),
    // Create: createAction(prefix + 'create', props<{ Payload: WarehouseMovementCreateRequest }>()),
    // Delete: createAction(prefix + 'delete', props<{ Payload: MaterialGroupTypeDeleteRequest }>()),

    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<WarehouseMovementEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<WarehouseMovementEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: MaterialAmountEntity }>()),
    // RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    LoadRequest: createAction(prefix + 'load/request', props<{ Payload: WarehouseMovementGetRequest }>()),
    LoadSuccess: createAction(prefix + 'load/success', props<{ Payload: WarehouseMovementEntity[] }>()),
    LoadFailure: createAction(prefix + 'load/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    ChangeRequest: createAction(prefix + 'change/request', props<{ Payload: WarehouseMovementEditRequest }>()),
    ChangeSuccess: createAction(prefix + 'change/success', props<{ Payload: WarehouseMovementEntity }>()),
    ChangeFailure: createAction(prefix + 'change/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: WarehouseMovementCreateRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: WarehouseMovementEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
